import React from "react";
import {Button, ButtonGroup, Icon} from "@material-ui/core";

export default function InputField(props) {
    const { buttons} = props;

    const buttonsComponents = buttons.map((button, i) => (
        <Button
            className={`customIconButton ${button.class}`}
            key={i}
            variant={button.varinat || 'outlined'}
            color={button.color || 'primary'}
            size={button.size}
            startIcon={<Icon className={button.icon}></Icon>}
            onClick={() => button.onClick() }
        >
            {button.label}
        </Button>
    ));
    return (
        <ButtonGroup style={{ display: 'flex',justifyContent: 'center' }} variant="text" color="primary" >
            {buttonsComponents}
        </ButtonGroup>
    );
}